import { useEffect } from 'react';
import { AppState, Platform } from 'react-native';
import { nativeLinkInbox } from '@/lib/nativeLinkInbox';
import { optionalMobileNativeModule, optionalNativeEvent } from '@/lib/mobileNativeCapabilities';

export default function MobileLaunchActionsHost() {
  useEffect(() => {
    const native = Platform.OS === 'ios' ? optionalMobileNativeModule('MobileLaunchActions', ['consume']) : null;
    if (!native) return;
    let active = true;
    const consume = async () => {
      try {
        const action = await native.consume();
        if (active && ['chat', 'voice', 'work'].includes(action)) nativeLinkInbox.capture(`/launch/${action}`);
      } catch {}
    };
    const events = optionalNativeEvent(native, 'onLaunchAction', consume);
    const foreground = AppState.addEventListener('change', state => { if (state === 'active') consume(); });
    consume();
    return () => { active = false; events?.remove(); foreground.remove(); };
  }, []);
  return null;
}
